import { createFileRoute } from '@tanstack/react-router'
import SeparatorPage from 'pages/app/separator/SeparatorPage'
import { getSeparator } from 'api/separator.api'

export const Route = createFileRoute(
  '/_authenticated/app/separators/$separatorId'
)({
  beforeLoad: async ({ context: { queryClient }, params }) => {
    await queryClient.ensureQueryData(getSeparator(Number(params.separatorId)));
  },
  component: SeparatorPage,
})
